/* eslint-disable jira/naming/disallow-filenames */
import React from 'react';
import { LazyPage } from '@jira/platform__spa/src/view/lazy-page/index.tsx';
import { lazyForPaint, type LazyComponent } from '@atlassian/react-loosely-lazy';

// oxlint-disable-next-line @typescript-eslint/no-explicit-any
export const LazyAlertList: LazyComponent<any> = lazyForPaint<any>(
	() =>
		import(
			/* webpackChunkName: "async-jira-eoc-alert-list", jiraSpaEntry: "async-jira-eoc-alert-list" */ '@jira/eoc__alert-list/src/ui/index.tsx'
		),
);

const AsyncAlertList = (): React.JSX.Element => (
	<LazyPage Page={LazyAlertList} pageId="async-jira-eoc-alert-list" shouldShowSpinner={false} />
);

export default AsyncAlertList;
